import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[appListingCountResultsLabel]',
    standalone: false
})
export class ListingCountResultsLabelDirective {

    constructor(public readonly templateRef: TemplateRef<any>) {
    }

}
